//@vendors
const Immutable = require('immutable');
const { handleActions } = require('redux-actions');
//@actions
const { simpleActions } = require('../actions/loanRecordStatus');
//@utilities
const { getEnableDocumentsFlowFlag } = require('../loansUtilities/loansHelper');

const setInitialState = () => Immutable.fromJS({
    recordId: 0,
    registerDate: '',
    state: '',
    success: false,
    isFetching: false,
    error: false,
    purpose: '',
    cardDeniedVisible: false,
    enableDocumentsFlow: false
});

const mapStatus = (state, response) => {

    const cardDeniedVisible = response.cardVisible;

    return state.merge({
        isFetching: false,
        error: false,
        success: true,
        state: response.status || '',
        productSubType: response.productSubType,
        registerDate: response.registerDate || '',
        recordId: response.recordId || 0,
        purpose: response.purpose || '',
        cardDeniedVisible,
        enableDocumentsFlow: getEnableDocumentsFlowFlag(response.status || '')
    });
};

const loanRecordStatusReducer = handleActions(
    {
        [simpleActions.loanRecordStatus]: state =>
            state.merge({
                isFetching: true,
                error: false
            }),
        [simpleActions.loanRecordStatusSuccess]: (state, action) =>
            mapStatus(state, action.payload.response),
        [simpleActions.loanRecordStatusError]: (state, action) =>
            state.merge({
                isFetching: false,
                error: action.payload.error
            })
    },
    setInitialState()
);

module.exports = loanRecordStatusReducer;
module.exports.setInitialState = setInitialState;
